module.exports = "/images/cd2899722bbe7a70498f6628d01eb55d.svg";